<render-slice
  data-e2e="slice-stacked"
  class="slice-stacked"
  *ngFor="let slice of stackedSlices; trackBy: trackBySlice"
  [attr.data-id]="slice ? slice.id : null"
  [slice]="slice">
</render-slice>
